import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, createBlock, unref, mergeProps, createCommentVNode, createVNode, withCtx, createTextVNode } from "vue";
import { CdrBreakpointMd, CdrBreakpointSm } from "@rei/cdr-tokens";
import { CdrText, CdrImg } from "@rei/cedar";
import _sfc_main$1 from "./AcquisitionBillboard/AcquisitionBillboard.mjs";
/* empty css                                            */
import _sfc_main$2 from "./RetentionBillboard/RetentionBillboard.mjs";
/* empty css                                        */
const _hoisted_1 = {
  class: "mbr-billboard__bg"
};
const _hoisted_2 = ["sizes"];
const _hoisted_3 = ["sizes"];
const _hoisted_4 = ["data-ui"];
const _hoisted_5 = {
  key: 2,
  class: "mbr-billboard__keep-shopping"
};
const _hoisted_6 = {
  class: "mbr-billboard__diamond"
};
const _hoisted_7 = ["srcset"];
const _hoisted_8 = ["srcset"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MembershipBillboard",
  props: {
    acquisitionBillboardProps: {
      default: null
    },
    activeBillboard: {
      default: ""
    },
    isInterstitial: {
      type: Boolean,
      default: false
    },
    retentionBillboardProps: {
      default: null
    },
    showAnyBillboard: {
      type: Boolean,
      default: false
    }
  },
  emits: ["acquisitionDetailsClick", "addMembershipToCart", "metricsClick", "retentionDetailsClick"],
  setup(__props) {
    const props = __props;
    const billboardBgImgSizes = computed(() => {
      if (props.isInterstitial) {
        return `(min-width: ${CdrBreakpointMd}px) 850px, (min-width: ${CdrBreakpointSm}px) 60vw, 100vw`;
      }
      return "100vw";
    });
    const containerClasses = computed(() => ({
      "mbr-billboard": true,
      [`mbr-billboard--${props.isInterstitial ? "interstitial" : "on-page"}`]: true
    }));
    const contentClasses = computed(() => `mbr-billboard__inner mbr-billboard__inner--${props.activeBillboard}`);
    const bgImgSrc = "https://www.rei.com/dam/20553394_samantha-m-jarem_web_lg.jpeg";
    const srcsetHighDpi = `
  ${bgImgSrc}?im=Resize,width=850 850w,
  ${bgImgSrc}?im=Resize,width=1280 1280w,
  ${bgImgSrc}?im=Resize,width=2000 2000w,
  ${bgImgSrc}?im=Resize,width=3500 3500w,
`;
    const srcsetLowDpi = `
  ${bgImgSrc}?im=Resize,width=850&density=1 850w,
  ${bgImgSrc}?im=Resize,width=1200&density=1 1200w,
  ${bgImgSrc}?im=Resize,width=1600&density=1 1600w
`;
    const memDiamondSrc = "https://www.rei.com/dam/21028995_-mem_membership_symbol_main_yellow.png";
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", {
        class: normalizeClass(containerClasses.value)
      }, [createElementVNode("picture", _hoisted_1, [createElementVNode("source", {
        media: "(-webkit-min-device-pixel-ratio: 1.5)",
        sizes: billboardBgImgSizes.value,
        srcset: srcsetHighDpi
      }, null, 8, _hoisted_2), createElementVNode("source", {
        sizes: billboardBgImgSizes.value,
        srcset: srcsetLowDpi
      }, null, 8, _hoisted_3), createElementVNode("img", {
        src: bgImgSrc,
        "aria-hidden": "true"
      })]), createElementVNode("div", {
        class: normalizeClass(contentClasses.value),
        "data-ui": _ctx.activeBillboard
      }, [_cache[6] || (_cache[6] = createElementVNode("div", {
        class: "mbr-billboard__marquee",
        "aria-hidden": "true"
      }, null, -1)), _ctx.activeBillboard === "acquisition" ? (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({
        key: 0
      }, _ctx.acquisitionBillboardProps, {
        onAddMembershipToCart: _cache[0] || (_cache[0] = (data) => _ctx.$emit("addMembershipToCart", data)),
        onMetricsClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("metricsClick", data)),
        onAcquisitionDetailsClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("acquisitionDetailsClick", data))
      }), null, 16)) : _ctx.activeBillboard === "retention" ? (openBlock(), createBlock(unref(_sfc_main$2), mergeProps({
        key: 1
      }, _ctx.retentionBillboardProps, {
        onMetricsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("metricsClick", data)),
        onRetentionDetailsClick: _cache[4] || (_cache[4] = (data) => _ctx.$emit("retentionDetailsClick", data))
      }), null, 16)) : createCommentVNode("", true), !_ctx.isInterstitial ? (openBlock(), createElementBlock("div", _hoisted_5, [createVNode(unref(CdrText), null, {
        default: withCtx(() => _cache[5] || (_cache[5] = [createTextVNode(" Keep shopping ")])),
        _: 1,
        __: [5]
      }), createVNode(unref(CdrImg), {
        src: "https://www.rei.com/dam/21389364_arrow.png?im=Resize,width=136",
        "aria-hidden": "true"
      })])) : createCommentVNode("", true), createElementVNode("div", _hoisted_6, [createElementVNode("picture", null, [createElementVNode("source", {
        media: "(-webkit-min-device-pixel-ratio: 1.5)",
        srcset: `${memDiamondSrc}?im=Resize,width=640`,
        sizes: "310px"
      }, null, 8, _hoisted_7), createElementVNode("source", {
        srcset: `${memDiamondSrc}?im=Resize,width=320&density=1`,
        sizes: "310px"
      }, null, 8, _hoisted_8), createElementVNode("img", {
        alt: "",
        "aria-hidden": "true",
        class: "mbr-billboard__diamond",
        src: memDiamondSrc,
        role: "presentation"
      })])])], 10, _hoisted_4)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=MembershipBillboard.mjs.map
